export const privacyTranslations = {
  PRIVACY_TITLE: 'Privacyverklaring',
  PRIVACY_SUBTITLE: 'versie',
};
